import { API_ENDPOINTS } from "./apiCall";

const BASE = API_ENDPOINTS.API_COMMAN_URL + 'Purchase/';

export const PURCHASE_API_ENDPOINTS = {
  VENDOR_ENQUIRY_WITH_PARTIES: `${BASE}VENDOR_ENQUIRY_WITH_PARTIES`,
  VENDOR_ENQUIRY_COMPARISION_LIST: `${BASE}VendorComparisonList`,
  VENDOR_ENQUIRY_QUOTATION_BY_PURCHASE: `${BASE}get-vendor-quotation-list-by-purchaseId`,
  VENDOR_ENQUIRY_COMPARISION_SAVE: `${BASE}UPSERT_COMPARISON`,
  VENDOR_ENQUIRY_COMPARISION_DET_BY_ID: `${BASE}get-vendor-quote-comparision-det-by-comparision-hdr-id`,
  VENDOR_ENQUIRY_COMPARISION_APPROVE: `${BASE}APPROVE_COMPARISON`,

    VENDOR_ENQUIRY_QUOTATION_BY_PURCHASE_NEW: `${BASE}get-vendor-enquiry-quotation-list-by-purchaseId`,

    VendorEnquiryMailSend :`${BASE}VendorEnquiryMailSend`,






};
